module.exports = __webpack_public_path__ + "static/media/asu-logo.44a7fcf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/asu-logo.png
// module id = 121
// module chunks = 0